import { replaceSearchParam } from '../src/replaceSearchParam.ts';
export default replaceSearchParam;
